import { render, staticRenderFns } from "./LisProject.vue?vue&type=template&id=dbf267e4&scoped=true"
import script from "./LisProject.vue?vue&type=script&lang=js"
export * from "./LisProject.vue?vue&type=script&lang=js"
import style0 from "./LisProject.vue?vue&type=style&index=0&id=dbf267e4&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbf267e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dbf267e4')) {
      api.createRecord('dbf267e4', component.options)
    } else {
      api.reload('dbf267e4', component.options)
    }
    module.hot.accept("./LisProject.vue?vue&type=template&id=dbf267e4&scoped=true", function () {
      api.rerender('dbf267e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/screeningConfig/lisProject/LisProject.vue"
export default component.exports